import React, { Component } from "react";
import Table from "../../components/Table/QuestionTable.jsx";
import { getGame, editGame,changeEntry, fixScale } from "../../services/GameServices";
import Moment from "react-moment";
import {
  Collapse,
  Alert,
  Button,
  FormControl,
  ControlLabel,
  FormGroup,
  Modal,
  Row,
  Col,
  Grid
} from "react-bootstrap";
import { Card } from "../../components/Card/Card.jsx";
import "../../assets/css/demo.css";
import "../../assets/css/new.css";

import {
  addQuestion,
  closeNotification,
  editQuestion,
  deleteQuestion
} from "../../services/QuestionServices";
// import { Route, Switch } from "react-router-dom";
// import { Socket } from "net";//not used

// const io = require('socket.io-client');
// const socket = io('house-of-theta-quiz.herokuapp.com', {transports: ['websocket']});

// const socket = io('http://localhost:5000', {transports: ['websocket']});
// const socket = io('http://139.162.247.113:3072', {transports: ['websocket']});
// TODO: Make header static, make page scroll to bottom on clicking add question button then up again

class ViewGame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal:false,
      game: "Game",
      gid:'',
      addQuestion: false,
      formTextField: "",
      formOrderField: "",
      alert: "warning",
      status: false,
      isButtonDisabled: false,
      message: "UNKNOWN",
      isShowing: false,
      qcounter: 0,
      source: "",
      value: "",
      url:"",
      msgObj: {
        lowest: "",
        low: "",
        mid: "",
        high:"",
        highest:""
      },
    };

    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateGame = this.updateGame.bind(this);
    this.handleQuestionUpdate = this.handleQuestionUpdate.bind(this);
    this.handleQuestionDelete = this.handleQuestionDelete.bind(this);
    this.toggleGameStatus = this.toggleGameStatus.bind(this);
    this.toggleStatus = this.toggleStatus.bind(this);
    

    //egthadat peter
    this.getNextQues = this.getNextQues.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  updateGame(gameId) {
    getGame(gameId).then(object => this.setState({ game: object.data.game }));
  }

  componentDidMount() {
    console.log(this.props.location);
    
    this.setState({url:this.props.location});

    const gameId = this.props.location.pathname.split("/")[2];
    this.setState({gid:gameId})
    this.updateGame(gameId);
    // TODO: Catch errors and display internal server error
  }
  
  componentWillUnmount(){
    this.setState({qcounter:0});
  }

  handleCloseClick() {
    this.setState({ addQuestion: false });
  }

  handleChangeText(e) {
    const target = e.target;
    this.setState({ formTextField: target.value });
  }

  handleChangeOrder(e) {
    const target = e.target;
    this.setState({ formOrderField: target.value });
  }

  handleQuestionUpdate(object) {
    const outsideThis = this;
    editQuestion(object._id, { text: object.text, order: object.order })
      .then(response => {
        if (response.data.err) {
          console.log(response.data.err);
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          const questions = this.state.game.questions.slice();

          let index;
          let question = questions.find((item, i) => {
            index = i;
            if (item._id === object._id){
              return item;
            }
            else{
              console.log("This may cause an error delete else statement if it does");
              return 0;
            }
          });

          question = Object.assign({}, response.data.question);
          questions[index] = question;

          const game = Object.assign({}, this.state.game);
          game.questions = questions;
          outsideThis.setState({
            message: "Updated question: " + response.data.question.text,
            isShowing: true,
            status: "SUCCESS!",
            alert: "success",
            game: game
          });
        }
      })
      .catch(err => {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
      });
  }

  handleQuestionDelete(object) {
    const outsideThis = this;
    deleteQuestion(object._id)
      .then(response => {
        if (response.data.err) {
          console.log(response.data.err);
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState({
            message: "Deleted question: " + object.text,
            isShowing: true,
            status: "SUCCESS!",
            alert: "success"
          });
        }
      })
      .catch(err => {
        console.log(err);
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
        outsideThis.updateGame(this.state.game._id);
      });
  }

  handleSubmit(e) {
    const outsideThis = this;
    this.setState({ isShowing: false });
    addQuestion({
      text: this.state.formTextField,
      order: this.state.formOrderField,
      game: this.state.game._id
    })
      .then(function(response) {
        if (response.data.err) {
          console.log(response.data.err);
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            addQuestion: false,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState(
            {
              message: "Added a new question: " + response.data.question.text,
              isShowing: true,
              addQuestion: false,
              status: "SUCCESS!",
              alert: "success"
            },
            () => outsideThis.updateGame(outsideThis.state.game._id)
          );
          console.log("oh?");
        }
      })
      .catch(function(err) {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
      });
  }

  toggleGameStatus() {
    const outsideThis = this;
    editGame(this.state.game._id, {status: !this.state.status})
    .then (response => {
    if (response.data.err) {
      outsideThis.setState({
        message:
          response.data.err.name ||
          response.data.err.code ||
          response.data.err,
        status: "ERROR!",
        alert: "danger"
      });
    } else {
      const game = response.data.game;
      delete game.questions;
      outsideThis.setState(prevState => {
        return {
        message: "Game " + (game.status)?"Started" : "Stopped",
        status: "SUCCESS!",
        alert: "success",
        game: {...prevState.game, ...game}
      }
    })
    }
    })
  .catch(err => {
    outsideThis.setState({
      message: err.name || err.code || err,
      status: "ERROR!",
      alert: "danger"
    });
  })
  .finally(args => {
    closeNotification(this);
  });
  }
  
  toggleStatus = () =>{
    console.log("Changing Quiz status");
    let st = this.state.status;
    let ist= !st;
    //make api call to change the entry value of the game 
    this.setState({status:ist})
    changeEntry(this.state.game._id,ist);
  }

  toggleModal = () =>{
    console.log("Toggling modal status");
    this.setState({showModal:true});
  }
  handleScaleChange(e, attribute) {
    const target = e.target;
    console.log("wording", target.value);
    let temp = Object.assign({}, this.state.msgObj);
    temp[attribute] = target.value;
    this.setState({ msgObj: temp });
  }
  handleCloseModal = () => {
    this.setState({ showModal: false });
    //any other actions after taking user input 
    //dispatch quiz's wording (fixed col)
    let vurl=this.state.msgObj;
    fixScale(this.state.game._id,vurl);
  }

  // streamVideo(){
  //   console.log("Video url sent to user");
  //   let vurl = this.state.value;
  //   console.log(vurl);
  //   sendVideo(this.state.game._id,vurl);
  // }
  
  getValidationState() {
    const length = this.state.value.length;
    if (length > 10) return 'success';
    else if (length > 0) return 'error';
    return null;
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  getNextQues(event){
    event.preventDefault();
    this.setState({
      isButtonDisabled: true
    });
    console.log("Next question is being sent");
    
    console.log(this.props.location);
    
    const selected = this.props.location.search.split("=")[1];
    console.log(selected);
    // alert("George did it ");
    // let q_num = this.state.qcounter ;
    
    let q_num = Number(selected) || this.state.qcounter ;
    // sendQuestion(this.state.game._id,q_num);
    //cut the below

    // this.state.qcounter = this.state.qcounter +1;
    
    setTimeout(() => this.setState({ isButtonDisabled: false }), 20000);

    // return this.props.getNextQues();
    // Socket.emit("sendquest");
  }

  render() {
    return (
      
      <div className="content">
        <div className="flex-container">
          <h1 align="center"> Name: &nbsp; {this.state.game.name}</h1>
          {this.state.status ? (
            <Button bsSize="large" bsStyle="danger" onClick={this.toggleStatus}>
              Remove Active
            </Button>
          ) : (
            <Button bsSize="large" bsStyle="success" onClick={ this.toggleStatus}>
              Set Active
            </Button>
          )}
          <Button bsSize="large" style={{marginLeft:10}}>
            <a href="https://quiz.houseoftheta.com">Go to Quiz </a>
          </Button>
          <Button bsSize="large" bsStyle="info" style={{marginLeft:10}} onClick={this.toggleModal}>
            Set Scale
          </Button>
            </div>
        <br />
        <div>
          <Modal
            show={this.state.showModal}
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Set Scale options</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <form>
              <FormGroup controlId="formBasicText">
                <Row>
                  <Col md={6}>
                    <ControlLabel>Lowest scale</ControlLabel>
                    <FormControl
                      type="text"
                      placeholder="enter the scale phrase"
                      onChange={e => this.handleScaleChange(e, "lowest")}
                      />
                 
                  </Col>
                  <Col md={6}>
                    <ControlLabel>Low scale</ControlLabel>
                    <FormControl
                      type="text"
                      placeholder="enter the scale phrase"
                      onChange={e => this.handleScaleChange(e, "low")}
                      />
                 
                  </Col>
                </Row>
                <Row style={{paddingTop:10}}>
                  <Col md={6}>
                    <ControlLabel>Mid scale</ControlLabel>
                    <FormControl
                      type="text"
                      placeholder="enter the scale phrase"
                      onChange={e => this.handleScaleChange(e, "mid")}
                      />
                 
                  </Col>
                  <Col md={6}>
                    <ControlLabel>High scale</ControlLabel>
                    <FormControl
                      type="text"
                      placeholder="enter the scale phrase"
                      onChange={e => this.handleScaleChange(e, "high")}
                      />
                 
                  </Col>
                </Row>
                <Row style={{paddingTop:10}}>
                  <Col md={6}>
                    <ControlLabel>Highest scale</ControlLabel>
                    <FormControl
                      type="text"
                      placeholder="enter the scale phrase"
                      onChange={e => this.handleScaleChange(e, "highest")}
                      />
                 
                  </Col>
                </Row>
              </FormGroup>
            </form>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="primary" onClick={this.handleCloseModal}>
                {" "}
                Update
              </Button>
            </Modal.Footer>
          </Modal>
          
        </div>
        <br />
        <h2 align="left">
          Broadcast Time: <Moment>{this.state.game.broadCastTime}</Moment>
        </h2>
        <h2> Add the questions for this quiz below</h2>
        <h3 align="left"> Questions:</h3>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Collapse in={this.state.isShowing}>
                <Row>
                  <Col xs={6} md={4}>
                    <Alert bsStyle={this.state.alert}>
                      <strong>{this.state.status}</strong> {this.state.message}
                    </Alert>
                  </Col>
                </Row>
              </Collapse>
              <Table
                objecttype="questions"
                questions={this.state.game.questions}
                attributes={["text","order"]}
                editableAttributes={["text", "order"]}
                gid={this.state.game._id}
                onUpdate={this.handleQuestionUpdate}
                onDelete={this.handleQuestionDelete}
              />
              {!this.state.addQuestion ? (
                <Button
                  onClick={() => this.setState({ addQuestion: true })}
                  className="right"
                  bsStyle="primary"
                  bsSize="large"
                >
                  Add a question
                </Button>
              ) : (
                <Card
                  onClick={this.handleCloseClick}
                  closable="true"
                  title="Add a new Question"
                  content={
                    <form>
                      <FormGroup controlId="formBasicText">
                        <Row>
                          <Col xs={6} md={4}>
                            <ControlLabel>Question Text</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.formTextField}
                              placeholder="Enter the text of the Question"
                              onChange={this.handleChangeText}
                            />
                          </Col>
                          <Col xs={6} md={4}>
                            <ControlLabel>Order</ControlLabel>
                            <FormControl
                              type="number"
                              min="1"
                              value={this.state.formOrderField}
                              placeholder="Enter the order size of the question"
                              onChange={this.handleChangeOrder}
                            />
                          </Col>
                        </Row>
                      </FormGroup>

                      <Button
                        onClick={this.handleSubmit}
                        bsStyle="info"
                        fill="true"
                      >
                        Add Question
                      </Button>
                      <div className="clearfix" />
                    </form>
                  }
                />
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ViewGame;



// WEBPACK FOOTER //
// ./src/views/Game/ViewGame.jsx